<template>
  <div class="pt-8 flex flex-col lg:flex-row p-4 min-h-screen bg-light-bg dark:bg-dark-bg dark:text-dark-text">
    <AppSidebar />

    <div class="flex flex-col flex-grow p-6 lg:p-12 space-y-4 h-full">
      <!-- Wiadomość sukcesu lub błędu -->
      <div v-if="message" :class="messageType" 
          class="fixed top-0 left-0 right-0 z-5 p-4 rounded-lg mb-4 text-center 
                  bg-white dark:bg-dark-box-bg dark:text-dark-text dark:border 
                  dark:border-dark-border">
          {{ message }}
          <div class="absolute bottom-0 left-0 h-1 rounded-lg" 
              :style="{ width: progress + '%', backgroundColor: getProgressColor(), borderRadius: '8px' }">
          </div>
      </div>

      <h1 class="text-xl md:text-2xl font-bold mb-4 text-center lg:text-left">Pasażerowie</h1>

      <PassengerCreateModal
          :isOpen="showCreateModal"
          @close="closeCreateModal"
          @submit="handleCreateSubmit"
      />

      <PassengerEditModal
          :isOpen="showEditModal"
          :editingPassenger="editingPassenger"
          @close="closeEditModal"
          @submit="handleEditSubmit"
      >
        <template>
          <div class="flex justify-between mt-4">
            <button @click="cancelEdit" class="text-gray-500 hover:text-gray-700 dark:text-dark-text">
              Anuluj
            </button>
            <button
                type="submit"
                class="w-full bg-gray-800 text-white py-2 rounded-md hover:bg-teal-700 focus:outline-none focus:ring focus:ring-indigo-500 dark:bg-dark-status-finished dark:hover:bg-dark-status-pending"
            >
              Zapisz zmiany
            </button>
          </div>
        </template>
      </PassengerEditModal>

      <div class="bg-white p-4 rounded-lg shadow-md w-full h-auto overflow-visible dark:bg-dark-box-bg dark:border dark:border-dark-border">
        <div class="flex flex-col md:flex-row items-start md:items-center justify-between mb-4">
          <h2 class="text-lg font-semibold text-gray-700 dark:text-dark-text">Lista Pasażerów</h2>

          <DynamicSearch
              :data="passengers"
              :keysToSearch="['firstName', 'lastName', 'city', 'phone']"
              @search-results="handleSearchResults"
              @clear-search="clearSearch"
              class="mt-4 bg-gray-200 dark:bg-dark-box-bg text-gray-900 dark:text-dark-text w-full md:w-auto"
              placeholder="Wyszukaj..."
          />
        </div>

        <div class="overflow-x-auto w-full">
          <table class="min-w-full bg-white border border-gray-300 rounded-lg dark:bg-dark-table-bg dark:border-dark-border">
            <thead>
            <tr class="bg-gray-50 dark:bg-dark-table-header">
              <th class="py-3 px-4 border-b border-gray-300 dark:border-dark-border text-left text-sm font-semibold text-gray-700 dark:text-dark-text">
                Nazwisko
              </th>
              <th class="py-3 px-4 border-b border-gray-300 dark:border-dark-border text-left text-sm font-semibold text-gray-700 dark:text-dark-text">
                Imię
              </th>
              <th class="py-3 px-4 border-b border-gray-300 dark:border-dark-border text-left text-sm font-semibold text-gray-700 dark:text-dark-text">
                Miasto
              </th>
              <th class="py-3 px-4 border-b border-gray-300 dark:border-dark-border text-left text-sm font-semibold text-gray-700 dark:text-dark-text">
                Telefon
              </th>
              <th class="py-3 px-4 border-b border-gray-300 dark:border-dark-border text-left text-sm font-semibold text-gray-700 dark:text-dark-text">
                Adres Zamieszkania
              </th>
              <th class="py-3 px-4 border-b border-gray-300 dark:border-dark-border text-left text-sm font-semibold text-gray-700 dark:text-dark-text">
                Adres Pracy
              </th>
<!--              <th class="py-3 px-4 border-b border-gray-300 dark:border-dark-border text-right text-sm font-semibold text-gray-700 dark:text-dark-text">-->
<!--                Akcje-->
<!--              </th>-->
            </tr>
            </thead>
            <tbody>
            <tr v-if="filteredPassengers.length === 0">
              <td colspan="7" class="text-center py-4 text-red-500 font-semibold dark:text-dark-status-unavailable">
                Brak pasażerów
              </td>
            </tr>
            <tr
                v-else
                v-for="(passenger) in paginatedPassengers"
                :key="passenger.id"
                :class="[
                    'border-b border-gray-300 dark:border-dark-border hover:bg-light-hover dark:hover:bg-dark-hover hover:cursor-pointer',
                    selectedPassenger && passenger.id === selectedPassenger.id ? 'bg-light-hover dark:bg-dark-hover' : ''
                ]"
                @click="showPassengerDetails(passenger)"
            >
              <td class="py-3 px-4 dark:text-dark-text">{{ passenger.lastName }}</td>
              <td class="py-3 px-4 dark:text-dark-text">{{ passenger.firstName }}</td>

              <td class="py-3 px-4 dark:text-dark-text">{{ passenger.city }}</td>
              <td class="py-3 px-4 dark:text-dark-text">{{ passenger.phone }}</td>
              <td class="py-3 px-4 dark:text-dark-text">{{ passenger.homeAddress }}</td>
              <td class="py-3 px-4 dark:text-dark-text">{{ passenger.workAddress }}</td>
<!--              <td class="py-3 px-4 text-right">-->
<!--                <div class="relative inline-block text-left">-->
<!--                  <button @click.stop="toggleDropdown(passenger.id)" class="text-gray-500 hover:text-gray-700 dark:text-dark-text">-->
<!--                    <EllipsisVerticalIcon class="h-5 w-5" />-->
<!--                  </button>-->
<!--                  <div v-if="dropdownOpen === passenger.id" class="origin-top-right absolute left-0 ml-[-10rem] mt-[-2.2rem] w-40 focus:outline-none">-->
<!--                    <div class="py-1.5 absolute flex space-x-2 bg-gray-200 dark:bg-gray-900 rounded">-->
<!--                      <button @click.stop="goToProfile(passenger)" class="text-left px-2 py-2 text-sm text-teal-700 dark:text-teal-400 flex items-center space-x-2">-->
<!--                        <UserIcon class="w-4 h-4" />-->
<!--                      </button>-->
<!--                      <button @click.stop="startEditing(passenger)" class="text-left px-2 py-2 text-sm text-teal-700 dark:text-teal-400 flex items-center space-x-2">-->
<!--                        <PencilIcon class="w-4 h-4" />-->
<!--                      </button>-->
<!--                      <button @click.stop="deletePassenger(passenger.id)" class="text-left px-2 py-2 text-sm text-teal-700 dark:text-teal-400 flex items-center space-x-2">-->
<!--                        <TrashIcon class="w-4 h-4" />-->
<!--                      </button>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </td>-->
            </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginacja -->
        <div class="mt-4 flex flex-col sm:flex-row items-center justify-between space-y-4 sm:space-y-0">
          <!-- Informacja o liczbie wyświetlanych elementów -->
          <div class="text-center sm:text-left text-sm text-light-text dark:text-gray-400">
            Wyświetlono {{ (currentPage - 1) * itemsPerPage + paginatedPassengers.length }} z {{ filteredPassengers.length }} pasażerów
          </div>

          <!-- Kontrolki paginacji -->
          <div class="flex flex-wrap justify-center sm:justify-end items-center gap-2">
            <!-- Przycisk "Pierwsza strona" -->
            <button v-if="currentPage > 1"
                    @click="goToPage(1)"
                    class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
              Pierwsza strona
            </button>

            <!-- Przycisk "Poprzednia" -->
            <button v-if="currentPage > 1"
                    @click="prevPage"
                    class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
              &laquo; Poprzednia
            </button>

            <!-- Numerowane strony -->
            <button v-for="page in visiblePages"
                    :key="page"
                    @click="goToPage(page)"
                    :class="[currentPage === page ? 'bg-teal-700 text-white' : 'bg-gray-200 dark:bg-dark-box-bg text-gray-700 dark:text-dark-text']"
                    class="px-3 py-1 text-sm font-medium rounded-md transition-colors hover:bg-teal-700 hover:text-white dark:hover:bg-teal-600 dark:hover:text-white">
              {{ page }}
            </button>

            <!-- Przycisk "Następna" -->
            <button v-if="currentPage < totalPages"
                    @click="nextPage"
                    class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
              Następna &raquo;
            </button>

            <!-- Przycisk "Ostatnia strona" -->
            <button v-if="currentPage < totalPages"
                    @click="goToPage(totalPages)"
                    class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
              Ostatnia strona
            </button>
          </div>
        </div>
      </div>
    </div>

    <button
        v-if="!showCreateModal && !editingPassenger"
        @click="openCreateModal"
        class="fixed bottom-8 right-8 bg-button-bg text-button-text p-4 rounded-full shadow-md transition-transform duration-200 ease-in-out hover:bg-button-hover dark:bg-dark-button-bg dark:hover:bg-dark-button-hover"
    >
      <PlusIcon class="h-6 w-6 transition-transform duration-200 ease-in-out transform hover:rotate-45"/>
    </button>
  </div>

  <PassengerInformationModal
            v-if="showModal"
            :visible="showModal"
            :title="'Szczegóły Pasażera #' + (selectedPassenger?.id || '')"
            :selectedPassenger="selectedPassenger"
            :userRole="user.role"
            @close="closeModalInformation"
            @goToProfile="goToProfile"
            @startEditing="startEditing"
            @deletePassenger="deletePassenger"
      >
          <div class="space-y-4">
            <p><b>ID Pasażera:</b> {{ selectedPassenger?.id }}</p>
            <p><b>Imie:</b> {{ selectedPassenger?.firstName }}</p>
            <p><b>Nazwisko:</b> {{ selectedPassenger?.lastName }}</p>
            <p><b>Telefon:</b> {{ selectedPassenger?.phone }}</p>
            <p><b>Miasto:</b> {{ selectedPassenger?.city }}</p>
            <p><b>Adres Domu:</b> {{ selectedPassenger?.homeAddress }}</p>
            <p><b>Adres Pracy:</b> {{ selectedPassenger?.workAddress }}</p>
          </div>
  </PassengerInformationModal>
</template>


<script>
import {useAuthStore} from '@/stores/authStore';
import passengersService from '@/services/passengersService';
import AppSidebar from "@/components/AppSidebar.vue";
import PassengerCreateModal from './PassengerCreateModal.vue';
import PassengerEditModal from './PassengerEditModal.vue';
import DynamicSearch from '../search/DynamicSearch.vue';

// import {EllipsisVerticalIcon, UserIcon, PencilIcon, TrashIcon, PlusIcon} from "@heroicons/vue/24/solid";
import { PlusIcon } from "@heroicons/vue/24/solid";
import PassengerInformationModal from './PassengerInformationModal.vue';
import { useSessionStore } from '@/stores/useSessionStore';

export default {
  name: "PassengersPageDispatcher",
  components: {
    // EllipsisVerticalIcon,
    // UserIcon,
    // PencilIcon,
    // TrashIcon,
    PlusIcon,
    AppSidebar,
    PassengerCreateModal,
    PassengerEditModal,
    DynamicSearch,
    PassengerInformationModal
  },

  computed: {
    paginatedPassengers() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredPassengers.slice(start, end);
    }
  },

  setup() {
    const authStore = useAuthStore();
    const sessionStore = useSessionStore();
    if (authStore.isAuthenticated) {
        authStore.checkExpiration();
    }
    return {user: authStore.user, sessionStore};
  },
  data() {
    return {
      message: '',
      messageType: '',
      progress: 0,
      passengers: [],
      filteredPassengers: [],
      editingPassenger: null,
      dropdownOpen: null,
      showCreateModal: false,
      showEditModal: false,
      loading: false,
      showModal: false,
      selectedPassenger: null,

      currentPage: 1,
      itemsPerPage: 5,
      totalPages: 0,
      visiblePages: [],
      isSearching: false,
    };
  },
  mounted() {
    this.calculateItemsPerPage();
    window.addEventListener("resize", this.calculateItemsPerPage);

    const pageFromUrl = parseInt(this.$route.query.currentPage) || 1;
    this.currentPage = pageFromUrl;

    this.fetchPassengers().then(() => {
      this.calculateTotalPages(); // Oblicz paginację
    });

    this.refreshPassengers();
  },
  beforeUnmount() {
    if (this.sessionStore.intervalId) {
      clearInterval(this.sessionStore.intervalId); // Oczyść interval, jeśli jest ustawiony
      this.sessionStore.intervalId = null; // Reset interval to prevent any issues if it tries to be cleared again
    }
    window.removeEventListener("resize", this.calculateItemsPerPage);
  },
  methods: {
    refreshPassengers() {
      this.sessionStore.startInterval(() => {
        if(!this.isSearching) {
          this.fetchPassengers();
        }
      }, 10000);
    },
    calculateItemsPerPage() {
      const width = window.innerWidth;

      if (width >= 3840) {
        this.itemsPerPage = 45; // 4K monitor
      } else if (width >= 2560) {
        this.itemsPerPage = 35; // 2K monitor
      } else if (width >= 1920) {
        this.itemsPerPage = 25; // Full HD monitor
      } else {
        this.itemsPerPage = 15; // Standardowa wartość
      }

      this.calculateTotalPages();
    },
    showPassengerDetails(passenger) {
      this.selectedPassenger = passenger; // Przypisz wybrane zamówienie
      this.showModal = true; // Pokaż modal
    },
    closeModalInformation() {
      this.selectedPassenger = null; // Wyczyść dane zamówienia
      this.showModal = false; // Zamknij modal
    },
    calculateTotalPages() {
      this.totalPages = Math.ceil(this.filteredPassengers.length / this.itemsPerPage) || 1;
      this.updateVisiblePages();
    },
    updateVisiblePages() {
      const range = 5; // Liczba stron widocznych na raz
      const start = Math.max(1, this.currentPage - Math.floor(range / 2));
      const end = Math.min(start + range - 1, this.totalPages);

      this.visiblePages = Array.from({length: end - start + 1}, (_, i) => start + i);
    },
    goToPage(page) {
      this.currentPage = page;
      this.updateVisiblePages();
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.updateVisiblePages();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.updateVisiblePages();
      }
    },
    showMessage(msg, type) {
      this.message = msg;
      this.messageType = type === 'success' ? 'success-message' : 'error-message';
      this.progress = 0;

      const interval = 30;
      const duration = 5000;
      const step = 100 / (duration / interval);

      const progressInterval = setInterval(() => {
        this.progress += step;
        if (this.progress >= 100) {
          clearInterval(progressInterval);
          this.progress = 0;
          this.message = '';
          this.messageType = '';
        }
      }, interval);
    },
    getProgressColor() {
      return this.messageType === 'success-message' ? '#16a34a' : '#b91c1c';
    },
    toggleDropdown(passengerId) {
      this.dropdownOpen = this.dropdownOpen === passengerId ? null : passengerId;
    },
    async fetchPassengers() {
      try {
        const response = await passengersService.getAllPassengers();
        this.passengers = response.data;
        this.filteredPassengers = this.passengers;
      } catch (error) {
        console.error('Błąd podczas pobierania pasażerów:', error);
      }
    },
    openCreateModal() {
      this.showCreateModal = true;
    },
    closeCreateModal() {
      this.showCreateModal = false;
    },
    openEditModal() {
      this.showEditModal = true;
    },
    closeEditModal() {
      this.showEditModal = false;
      this.editingPassenger = null;
    },
    handleSearchResults(filteredData) {
      this.filteredPassengers = filteredData;
      this.calculateTotalPages();

      this.isSearching = filteredData.length > 0;

      this.goToPage(1);
    },
    clearSearch() {
      this.isSearching = false;

      this.goToPage(1);
    },
    async handleCreateSubmit(newPassenger) {
      if (this.loading) return;
      this.loading = true;
      try {
        await passengersService.createPassenger(newPassenger);
        await this.fetchPassengers();
        this.closeCreateModal();
        this.showMessage("Pasażer został pomyślnie dodany.", "success");
      } catch (error) {
        console.error('Błąd podczas tworzenia pasażera:', error);
        this.showMessage("Wystąpił błąd podczas dodawania pasażera.", "error");
      } finally {
        this.loading = false;
      }
    },
    startEditing(passenger) {
      this.editingPassenger = {...passenger};
      this.showModal = false;
      this.openEditModal();
    },
    async handleEditSubmit(updatedPassenger) {
      if (this.loading) return;
      this.loading = true;
      try {
        await passengersService.updatePassenger(updatedPassenger.id, updatedPassenger);
        await this.fetchPassengers();
        this.closeEditModal();
        this.showMessage("Pasażer został pomyślnie zaktualizowany.", "success");
      } catch (error) {
        console.error('Błąd podczas aktualizacji pasażera:', error);
        this.showMessage("Wystąpił błąd podczas aktualizacji pasażera.", "error");
      } finally {
        this.loading = false;
      }
    },
    goToProfile(passenger) {
      const currentPage = this.currentPage;

      if (this.user.role === 'ROLE_ADMIN') {
        this.$router.push({
          name: 'PassengerProfileAdmin', 
          params: {id: passenger.id},
          query: {
            currentPage: currentPage,
          }
        });
      } else {
        this.$router.push({
          name: 'PassengerProfileDispatcher', 
          params: {id: passenger.id},
          query: {
            currentPage: currentPage,
          }
        });
      }
    },
    async deletePassenger(passengerId) {
      if (confirm("Czy na pewno chcesz usunąć tego pasażera?")) {
        try {
          await passengersService.deletePassenger(passengerId);
          await this.fetchPassengers();
          this.showMessage("Pasażer został pomyślnie usunięty.", "success");
          this.closeModalInformation();
        } catch (error) {
          console.error('Błąd podczas usuwania pasażera:', error);
          this.showMessage("Wystąpił błąd podczas usuwania pasażera.", "error");
        }
      }
    },
    cancelEdit() {
      this.editingPassenger = null;
      this.closeEditModal();
    }
  }
};
</script>
